export default "__VITE_ASSET__DUgswuVR__"